import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import URLSearchParams from 'url-search-params'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch
} from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import AppLocale from '../../lngProvider/index'
import { setInitUrl } from '../../appRedux/actions/Auth'
import { ConfigProvider } from 'antd'
import MainApp from './MainApp'
import {
  onLayoutTypeChange,
  onNavStyleChange,
  setThemeType,
  updateWindowWidth
} from '../../appRedux/actions/Setting'
import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from '../../constants/ThemeSetting'
import {
  checkIndexedOfflineSales,
  checkUserVerifyPage,
  getMenu,
  isEmptyObject,
  loadIsOnline,
  loadOutletRegisters,
  loadReceiptTemplates,
  loadRegOutletsLoading,
  loadSellAttributesGroups,
  loadStoreChange,
  loadStoreOutlets,
  loadStoreUsers,
  non_net_redirect,
  settleRegChecks
} from '../../appRedux/actions'
import OutletRegSelect from '../../components/OutletRegSelect'
import InfoToPrint from '../../components/InfoToPrint'
import { BUS_SITE_LOCAL_IP, SYNC_TIME_GAP } from '../../constants/StoreSetting'
import {
  checkAndSyncData,
  initializeIndexedDB,
  loadEntitiesSyncDataCount
} from '../../appRedux/actions/IndexDBActions'
import { clearInterval, setInterval } from 'timers' // Importing clearInterval and setInterval
import moment from 'moment'
import { DURATION } from '../../constants/IndexDBData'
import {
  APP_BASE_LOCAL_URL,
  APP_STORE_WEB_URL
} from '../../Services/DataServices'
import { checkIsWeb, isReportingApp } from '../../appRedux/actions/MobAppFn'

const RestrictedRoute = ({
  component: Component,
  location,
  token,
  ...rest
}) => (
  <Route
    {...rest}
    render={
      props =>
        token ? (
          <Component {...props} />
        ) : location.pathname.split('/')[1] == 'UserVerify' ? (
          <Component {...props} />
        ) : (
          (window.location.href = '/signin')
        ) //< Redirect to={{ pathname: '/signin', state: { from: location } }} />
    }
  />
)

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const match = useRouteMatch()
  const Store = useStore()
  const token = localStorage.getItem('token')

  const { locale, navStyle, layoutType } = useSelector(
    ({ settings }) => settings
  )
  const getConfigSellAttribute = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellAttribute
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const showPrint = useSelector(({ commonConfigs }) => commonConfigs.showPrint)
  const printData = useSelector(({ commonConfigs }) => commonConfigs.printData)
  const storeUsersChange = useSelector(({ Setup }) => Setup.storeUsersChange)
  const getReduxTemplatesUpdated = useSelector(
    ({ Setup }) => Setup.isReceiptTemplateUpdated
  )
  // const isMobApp = useSelector(({ commonConfigs }) => commonConfigs.isMobApp)
  const isAppOnline = useSelector(
    ({ commonConfigs }) => commonConfigs.isAppOnline
  )
  const getReduxOpenListingDataLoad = useSelector(
    ({ Sell }) => Sell.openCloseListingDataLoad
  )
  const getReduxCashListingDataLoading = useSelector(
    ({ Sell }) => Sell.cashListingDataLoading
  )
  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )

  const { initURL } = useSelector(({ auth }) => auth)
  const [getSelectedOutlet, setSelectedOutlet] = React.useState({})
  const [getSelectedReg, setSelectedReg] = React.useState({})
  const [languageId, setLanguageId] = React.useState('en')
  const [getIsPageReload, setIsPageReload] = React.useState(true)

  useEffect(() => {
    let link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = '/css/style.css'
    link.className = 'gx-style'
    document.body.appendChild(link)
  })

  //#region isOnlineCheck
  useEffect(() => {
    dispatch(loadIsOnline(navigator.onLine))
    const handleOnline = () => {
      dispatch(loadIsOnline(true))
    }
    const handleOffline = () => {
      dispatch(loadIsOnline(false))
    }
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // useEffect(() => {
  //   const handleOnline = () => {
  //     dispatch(loadIsOnline(true))
  //   }
  //   const handleOffline = () => {
  //     dispatch(loadIsOnline(false))
  //   }

  //   if (isEmptyObject(isAppOnline)) {
  //     dispatch(loadIsOnline(navigator.onLine))
  //     window.addEventListener('online', handleOnline)
  //     window.addEventListener('offline', handleOffline)
  //   } else {
  //     if (!isEmptyObject(isAppOnline)) {
  //       if (isAppOnline.id) {
  //         if (isAppOnline.data) handleOnline()
  //         else handleOffline()
  //       }
  //     }
  //   }

  //   return () => {
  //     if (isEmptyObject(isAppOnline)) {
  //       window.removeEventListener('online', handleOnline)
  //       window.removeEventListener('offline', handleOffline)
  //     }
  //   }
  // }, [isAppOnline])

  //#endregion

  //#region Syncing Mechanism
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      async function fetchData () {
        try {
          await initializeIndexedDB()
          setTimeout(() => {
            if (navigator.onLine) {
              dispatch(loadEntitiesSyncDataCount())
            }
          }, 1000) // Delay in milliseconds
        } catch (error) {
          console.error('Error:', error)
        }
      }
      fetchData()
    }
    return () => {
      mounted = false
    }
  }, [])

  useEffect(() => {
    if (
      localStorage.getItem('IsPageReload') === null ||
      localStorage.getItem('IsPageReload') === 'false'
    ) {
      localStorage.setItem('IsPageReload', 'true')
    }

    const intervalId = setInterval(() => {
      if (shouldSyncData() || localStorage.getItem('IsPageReload') === 'true') {
        if (navigator.onLine) {
          dispatch(loadEntitiesSyncDataCount())
          checkAndSyncData()
        }
        if (localStorage.getItem('IsPageReload') === 'true') {
          localStorage.setItem('IsPageReload', 'false') // Set to false after initial page load
        }
        localStorage.setItem('LastRunDateTime', moment().valueOf().toString())
      }
    }, 30000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  function shouldSyncData () {
    const lastRunDateTime = localStorage.getItem('LastRunDateTime')
    if (!lastRunDateTime) {
      // First load or page reloaded
      return true
    }

    const currentTime = moment()
    const lastRunTime = moment(parseInt(lastRunDateTime, 10))

    // Use the generic DURATION constant
    return currentTime.diff(lastRunTime, 'minutes') >= DURATION.asMinutes()
  }
  //#endregion

  useEffect(() => {
    const baseURL = window.location.origin
    const storeName = localStorage.getItem('storeName')
    const storeUrl = APP_STORE_WEB_URL.replace('[domain]', storeName)
    const fullUrl = window.location.href
    const redirectURL = fullUrl.replace(baseURL, storeUrl)
    //console.log("BASE: "+baseURL);
    //console.log("STORE: "+storeUrl);
    //console.log("REDIRECT: "+redirectURL);
    if (
      storeUrl &&
      APP_BASE_LOCAL_URL != baseURL &&
      BUS_SITE_LOCAL_IP != baseURL &&
      baseURL != storeUrl &&
      !window.location.pathname.toLocaleLowerCase().includes('loginstore') &&
      !checkUserVerifyPage()
    ) {
      window.location.href = redirectURL
    }
    window.addEventListener('resize', () => {
      dispatch(updateWindowWidth(window.innerWidth))
    })
  }, [dispatch])

  React.useEffect(() => {
    //console.log(Store.getState())
    const unsub = Store.subscribe(handleHistoryMenu)
    dispatch(getMenu())
    //unsub();
    //refSate.current=true;
    return () => {
      unsub()
    }
  }, [languageId])

  useEffect(() => {
    if (initURL === '') {
      dispatch(setInitUrl(location.pathname))
    }
    const params = new URLSearchParams(location.search)

    if (params.has('theme')) {
      dispatch(setThemeType(params.get('theme')))
    }
    if (params.has('nav-style')) {
      dispatch(onNavStyleChange(params.get('nav-style')))
    }
    if (params.has('layout-type')) {
      dispatch(onLayoutTypeChange(params.get('layout-type')))
    }
    setLayoutType(layoutType)
    setNavStyle(navStyle)
  }, [
    dispatch,
    initURL,
    layoutType,
    location.pathname,
    location.search,
    navStyle
  ])

  useEffect(() => {
    if (location.pathname === '/') {
      if (token === null) {
        history.push('/dashboard')
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        history.push('/dashboard')
      } else {
        history.push(initURL)
      }
    }
  }, [token, initURL, location, history])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      //NOTE: check if to load attributes
      if (getConfigSellAttribute) {
        dispatch(loadSellAttributesGroups(isOnline))
      }
    }
    return () => (mounted = false)
  }, [getConfigSellAttribute])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      let selectedLocalReg = localStorage.getItem('selectedReg')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        if (selectedLocalOut.id) {
          let body = {
            OutletID: selectedLocalOut.id
          }
          dispatch(loadRegOutletsLoading(true))
          dispatch(loadOutletRegisters(body, isOnline))
        }
        setSelectedOutlet(selectedLocalOut)
      }
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg)
        setSelectedReg(selectedLocalReg)
      }
    }

    return () => (mounted = false)
  }, [isOnline])

  React.useEffect(() => {
    let intervalId = null // Initialize interval ID

    const startInterval = () => {
      intervalId = setInterval(() => {
        if (isOnline) {
          checkIndexedOfflineSales() // SYNCING CALL
        }
      }, SYNC_TIME_GAP)
    }
    // Start the interval when the component mounts or when isOnline becomes true
    if (isOnline) {
      startInterval()
    }

    // Listen for changes in isOnline
    const handleOnlineStatusChange = () => {
      if (isOnline) {
        startInterval() // Start the interval when isOnline becomes true
      } else {
        clearInterval(intervalId) // Clear the interval when isOnline becomes false
      }
    }

    // Attach event listener for online/offline events
    window.addEventListener('online', handleOnlineStatusChange)
    window.addEventListener('offline', handleOnlineStatusChange)

    return () => {
      // Clean up event listeners and clear the interval when the component unmounts
      window.removeEventListener('online', handleOnlineStatusChange)
      window.removeEventListener('offline', handleOnlineStatusChange)
      clearInterval(intervalId)
    }
  }, [isOnline])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      non_net_redirect(history, !isOnline)
      if (!checkUserVerifyPage() && !isReportingApp()) {
        if (isOnline) {
          dispatch(loadStoreOutlets(true))
        }
      }
    }

    return () => {
      mounted = false
    }
  }, [isOnline])

  //forReceiptTemplates
  React.useEffect(() => {
    if (!checkUserVerifyPage()) {
      dispatch(loadReceiptTemplates(isOnline))
    }
  }, [getReduxTemplatesUpdated, isOnline])

  React.useEffect(() => {
    //load store users
    let mounted = true
    if (mounted && !checkUserVerifyPage() && storeUsersChange) {
      dispatch(loadStoreUsers())
      dispatch(loadStoreChange(false))
    }
    return () => (mounted = false)
  }, [storeUsersChange])

  React.useEffect(() => {
    // //  NOTE: register open check
    let mounted = true
    if (
      mounted &&
      !isReportingApp() &&
      window.location.pathname.toLowerCase().includes('/sell')
    ) {
      settleRegChecks(
        dispatch,
        getReduxSelectedOutletReg,
        isOnline,
        getReduxOpenListingDataLoad,
        getReduxCashListingDataLoading
      )
    }
    return () => {
      mounted = false
    }
  }, [getReduxIsRegisterOpen, getReduxSelectedOutletReg, isOnline, window.location.pathname])

  const handleHistoryMenu = () => {
    //console.log(Store.getState().settings.locale.locale);
    if (languageId != Store.getState().settings.locale.locale) {
      setLanguageId(Store.getState().settings.locale.locale)
      // dispatch(getMenu());
    }
    /* if(Store.getState().auth.reloadMenu){
           // unsub();
            
           dispatch(getMenu())
           // var menuNavigationData = localStorage.getItem('menu');
           // renderWholeMenu();
        }*/
  }

  const setLayoutType = layoutType => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('framed-layout')
      document.body.classList.add('full-layout')
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout')
      document.body.classList.remove('framed-layout')
      document.body.classList.add('boxed-layout')
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('full-layout')
      document.body.classList.add('framed-layout')
    }
  }

  const setNavStyle = navStyle => {
    if (
      navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER
    ) {
      document.body.classList.add('full-scroll')
      document.body.classList.add('horizontal-layout')
    } else {
      document.body.classList.remove('full-scroll')
      document.body.classList.remove('horizontal-layout')
    }
  }

  // useEffect(() => {
  //
  //   if (!isEmptyObject(isAppOnline)) {
  //     if (isAppOnline.id) {
  //       if (isAppOnline.data) dispatch(loadIsOnline(true))
  //       else dispatch(loadIsOnline(false))
  //     }
  //   }
  // }, [isAppOnline])

  const currentAppLocale =
    AppLocale[locale && !isEmptyObject(locale) ? locale.locale : 'en']
  return (
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Switch>
          <RestrictedRoute
            path={`${match.url}`}
            token={token}
            location={location}
            component={MainApp}
          />
        </Switch>
        <OutletRegSelect
          out={
            getReduxSelectedStoreOutlets && getReduxSelectedStoreOutlets.id
              ? getReduxSelectedStoreOutlets
              : getSelectedOutlet && getSelectedOutlet.id
              ? getSelectedOutlet
              : false
          }
          reg={
            getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
              ? getReduxSelectedOutletReg
              : getSelectedReg && getSelectedReg.id
              ? getSelectedReg
              : false
          }
        />
        <InfoToPrint
          customPrint={showPrint}
          printExtraData={printData}
          role={'OPENCLOSE_PRINT'}
          showExtraPrinters={
            !checkIsWeb().exist
              ? localStorage.getItem('extraPrints') &&
                localStorage.getItem('extraPrints') == '1'
                ? true
                : false
              : false
          }
        />
      </IntlProvider>
    </ConfigProvider>
  )
}

export default memo(App)
